import React, { useContext } from 'react';

import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';

const SuccessRegistration = ({ popupType }) => {
  const t = useTranslation();
  const [{ openPopup, closePopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small">
      <div className="title-row">
        <p className="title-row-text">
          {t('Congratulations')}
          !
        </p>
      </div>
      <div className="main-middle-row">
        <div className="container-for-icon">
          <i className="global-icon icon-successRegistration main-middle-icon" />
        </div>
      </div>
      <div className="central-text-row">
        <p className="central-text">
          {t('Your registration was successful and a ticket containing your credentials has been printed')}
          .
        </p>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={closePopup}
          className="popup-cancel-button"
        >
          {t('Close')}
        </button>
        <button
          type="button"
          onClick={() => openPopup(popupType || POPUPS.SIGN_IN)}
          className="popup-confirm-button"
        >
          {t('Login')}
        </button>
      </div>
    </div>
  );
};

export default SuccessRegistration;
